
import { defineComponent, inject, computed, PropType, ComputedRef } from 'vue'
import { AgendaTableData } from '@/services/agenda'
import AgendaSessionItem from './AgendaSessionItem.vue'
import AgendaTableRoomCell from './AgendaTableRoomCell.vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'AgendaTable',
  components: {
    AgendaTableRoomCell,
    AgendaSessionItem
  },
  props: {
    table: {
      type: Object as PropType<AgendaTableData>,
      required: true
    }
  },
  setup (props) {
    const router = useRouter()
    const languageType = inject<ComputedRef<'zh' | 'en'>>('languageType') || { value: 'zh' }
    const tableStyle = computed(() => ({ '--table-column': props.table.rooms.length }))
    const getSessionLocation = (sessionId: string) => ({
      name: 'AgendaDetail',
      params: {
        ...router.currentRoute.value.params,
        sessionId
      }
    })

    return {
      languageType,
      tableStyle,
      getSessionLocation
    }
  }
})
